export default {
    FETCHED_PENDING: 'FETCHED_PENDING',
    FETCHED_MERCHANT_PENDING: 'FETCHED_MERCHANT_PENDING',
    FETCHED_PENDING_DETAILS: 'FETCHED_PENDING_DETAILS',
    DELETE_PENDING:'DELETE_PENDING'
}